import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const SuccessPage = () => {
  const location = useLocation();
  const { bookingId, spotId, userData } = location.state || {};

  return (
    <div style={styles.container}>
      <div style={styles.successBox}>
        <div style={styles.successIcon}>✓</div>
        <h1 style={styles.title}>Success!</h1>
        <p style={styles.message}>
          Your parking check-in has been completed successfully.
        </p>

        {bookingId && spotId && userData && (
          <div style={styles.details}>
            <h3 style={styles.detailsTitle}>Booking Details</h3>
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Booking ID:</span>
              <span style={styles.detailValue}>{bookingId}</span>
            </div>
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Parking Spot:</span>
              <span style={styles.detailValue}>{spotId}</span>
            </div>
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>Name:</span>
              <span style={styles.detailValue}>{userData.name}</span>
            </div>
            <div style={styles.detailRow}>
              <span style={styles.detailLabel}>License Plate:</span>
              <span style={styles.detailValue}>{userData.licensePlate}</span>
            </div>
          </div>
        )}

        <div style={styles.actions}>
          <Link to="/" style={styles.homeBtn}>
            Back to Home
          </Link>
          <Link to="/checkin" style={styles.newCheckInBtn}>
            New Check-In
          </Link>
        </div>

        <div style={styles.note}>
          <p>Please keep this booking ID for your records.</p>
          <p>Have a great day!</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  successBox: {
    maxWidth: '600px',
    width: '100%',
    backgroundColor: 'white',
    padding: '50px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    textAlign: 'center',
  },
  successIcon: {
    width: '80px',
    height: '80px',
    backgroundColor: '#4CAF50',
    color: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    margin: '0 auto 30px',
    fontWeight: 'bold',
  },
  title: {
    fontSize: '36px',
    color: '#333',
    marginBottom: '15px',
  },
  message: {
    fontSize: '18px',
    color: '#666',
    marginBottom: '40px',
  },
  details: {
    backgroundColor: '#f9f9f9',
    padding: '25px',
    borderRadius: '8px',
    marginBottom: '30px',
    textAlign: 'left',
  },
  detailsTitle: {
    fontSize: '20px',
    color: '#333',
    marginBottom: '20px',
    textAlign: 'center',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #e0e0e0',
  },
  detailLabel: {
    fontWeight: 'bold',
    color: '#555',
  },
  detailValue: {
    color: '#333',
  },
  actions: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    marginBottom: '30px',
  },
  homeBtn: {
    padding: '12px 30px',
    backgroundColor: '#3498db',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
  },
  newCheckInBtn: {
    padding: '12px 30px',
    backgroundColor: '#4CAF50',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
  },
  note: {
    fontSize: '14px',
    color: '#999',
    lineHeight: '1.6',
  },
};

export default SuccessPage;
